import React from "react";
import styled from "styled-components";

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", "Arial", sans-serif;
  min-height: 60vh;
  text-align: center;
`;

const LoginCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 400px;
`;

const Title = styled.h2`
  color: #323130;
  margin-bottom: 1rem;
`;

const Description = styled.p`
  color: #605e5c;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0078d4;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 2rem;

  &:hover {
    background-color: #106ebe;
  }
  img {
    height: 24px;
    margin-right: 0.75rem;
  }
`;

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  return (
    <LoginContainer>
      <LoginCard>
        <Title></Title>
        <Description>Welcome to ARC Policy Chatbot !</Description>
        <LoginButton onClick={onLogin}>
          <img src="/img/Microsoft_Azure.svg" alt="Azure Logo" />
          Sign in with Azure
        </LoginButton>
      </LoginCard>
    </LoginContainer>
  );
};

export default Login;
